import { LoadingOutlined } from "@ant-design/icons";
import { LoadLayoutViewModel } from "@core/presentation/components/feedback/load-layout/load-layout.viewmodel.ts";
import { IotSpin } from "@core/presentation/components/feedback/spin/iot-spin.component";
import { IotCol } from "@core/presentation/components/layout/col/iot-col.component";
import { container } from "@di/inversify.config";
import { useViewModel } from "@iot-platform/core";
import { observer } from "mobx-react";
import type { FC, PropsWithChildren } from "react";

export type LoadLayoutProps = PropsWithChildren;

export const LoadLayout: FC<LoadLayoutProps> = observer(({ children }) => {
    const viewModel = useViewModel(() => container.get(LoadLayoutViewModel));

    return (
        <IotSpin
            size={"large"}
            indicator={<LoadingOutlined />}
            spinning={viewModel.loading}
        >
            <IotCol className={"tw:h-[100vh]"}>{children}</IotCol>
        </IotSpin>
    );
});

LoadLayout.displayName = "LoadLayout";
